import axios from 'axios'
import { recordToMap } from '../../helpers/record-to-map'

export const getGeolocation = async (coords, options) => {
  if (Array.isArray(coords) && coords.length === 0) return new Map()

  const format = options?.format ?? 'json'
  const cache = options?.cache ?? true
  const coordsArr = Array.isArray(coords) ? coords : [coords]

  const data = await axios
    .post(process.env.VUE_APP_API_GEOLOCATION_URL + '/reverse', {
      language: 'id',
      coords: coordsArr,
      format,
      cache,
    })
    .then((res) => {
      return recordToMap(res.data.data)
    })
    .catch((err) => {
      throw new Error(`Failed Getting Coordinates: ${err.message}`)
    })

  return data
}

// To centralize what kind of key we are using to get the address
export const getAddress = (addresses, lat, lon) => {
  if (lat === undefined || lat === null || lon === undefined || lon === null) return undefined

  const key = `${lat},${lon}`

  return addresses.get(key)
}
